import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Navbar from "../../components/Navbar";
import LabelList from "../../components/Label/LabelList";
import { useLocation, Link } from "react-router-dom";
import "./LabelListPage.css";
import CSVImportModal from "../../components/CSVImportModal";

const LabelListPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dicomId = searchParams.get("dicom_id");
  let createLink = `/fsa_labels/create`;
  if (dicomId) createLink += `?dicom_id=${dicomId}`;

  const [isModalOpen, setModalOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const downloadTimeoutRef = useRef(null);
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const handleRefresh = () => setRefreshData((prev) => prev + 1);

  useEffect(() => {
    console.log(selectedIds);
  }, [selectedIds]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (showDownloadDropdown && !event.target.closest('.download-dropdown-container')) {
        setShowDownloadDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDownloadDropdown]);

  const handleDownload = (onlyCsv) => {
    if (selectedIds.length === 0) {
      alert("Please select at least one label to download");
      return;
    }
    if (downloadInProgress) {
      return;
    }

    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
    }

    downloadTimeoutRef.current = setTimeout(async () => {
      setDownloadInProgress(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/patients/fsa_labels/download?onlyCsv=${onlyCsv}`,
          {
            params: { 
              id: selectedIds.join(","),
              onlyCsv: onlyCsv
            },
            headers: { Authorization: `Token ${token}` },
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        
        const timestamp = new Date().toISOString().replace(/[:.]/g, "").substring(0, 15);
        const filename = onlyCsv ? `fsa_labels_${timestamp}.csv` : `fsa_labels_${timestamp}.zip`;
        link.setAttribute("download", filename);
        
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading labels:", error);
        alert("Error downloading labels. Please try again.");
      }
      setDownloadInProgress(false);
      setShowDownloadDropdown(false);
    }, 300);
  };

  return (
    <div className="label-list-page">
      <Navbar />
      <div className="label-list-content">
        <div className="label-header-section">
          <h2>FSA Labels</h2>
          <div className="button-group">
            <Link to={createLink} className="label-create-btn-main">
              New FSA Label
            </Link>
            <button className="csv-import-btn" onClick={openModal}>
              CSV Import
            </button>
            
            <div className="download-dropdown-container">
              <button
                className="download-btn"
                onClick={() => setShowDownloadDropdown(!showDownloadDropdown)}
                disabled={selectedIds.length === 0 || downloadInProgress}
              >
                Download Selected ({selectedIds.length}) ▼
              </button>
              
              {showDownloadDropdown && (
                <div className="download-dropdown-menu">
                  <button 
                    onClick={() => handleDownload(true)}
                    disabled={downloadInProgress}
                  >
                    Download CSV
                  </button>
                  <button 
                    onClick={() => handleDownload(false)}
                    disabled={downloadInProgress}
                  >
                    Download All Data
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <LabelList refreshData={refreshData} onSelectedIdsChange={setSelectedIds} />
      </div>

      <CSVImportModal
        type={"fsa_labels"}
        isOpen={isModalOpen}
        onClose={closeModal}
        onSuccess={() => {
          handleRefresh();
          closeModal();
        }}
      />
    </div>
  );
};

export default LabelListPage;
